import { getEnvVariable } from 'utils/env';

export const IS_PRODUCTION = getEnvVariable('adminIsProd', process.env.NODE_ENV === 'production');

export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';

export const IS_LOCAL_DEVELOPMENT = process.env.LOCAL_DEVELOPMENT === 'true';

export const DEFAULT_ENV_IMAGES = {
  LOGO: 'header-logo.png',
  FAVICON: 'favicon.png',
  FOOTER_LOGO: 'footer-logo.png',
};

export const INTERCOM_APP_ID = getEnvVariable('intercomAppId', process.env.INTERCOM_APP_ID) || null;
